// @ts-ignore
import is from 'is_js';

function isWX() {
  const ua = window.navigator.userAgent.toLowerCase() ?? '';
  // @ts-ignore
  return ua.match(/MicroMessenger/i) === 'micromessenger';
}

export const getAppKey = () => {
  if (isWX()) return '8Sdq3Sp8vvgwhfqy64gwMDsjnR97fM7n';
  if (is.mobile()) return '424yhBNf3qnH5tZS5Jk8673K7hGy9yzr';
  return 'eByjUyLDG2KtkdhuTsw2pY46Q3ceBPdT';
};
